import { useRouter } from '@tanstack/react-router';

export function RootErrorFallback() {
  const router = useRouter();

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="max-w-md text-center">
        <h1 className="font-bold text-2xl">Something went wrong</h1>
        <p className="mt-2 text-gray-500">An unexpected error occurred.</p>
        <button
          type="button"
          className="mt-4 rounded-md bg-gray-900 px-4 py-2 text-sm text-white hover:bg-gray-800"
          onClick={() => router.navigate({ to: '/' })}
        >
          Go home
        </button>
      </div>
    </div>
  );
}
